module.exports = __webpack_public_path__ + "static/oid-el-ruido-de-rotas-cadenas_2010-f9947c60e42702d41977f9a1736993d5.jpg";